"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _cuid = _interopRequireDefault(require("cuid"));

var ThumbUpFill = function ThumbUpFill(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, props, {
    uniqueId: uniqueId,
    iconName: "ThumbUpFill"
  }), /*#__PURE__*/_react["default"].createElement("title", null, "thumb-up-fill"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.76 18.82c-0.011 0.515-0.425 0.929-0.939 0.94l-0.001 0h-2.86c-0 0-0 0-0 0-0.523 0-0.949-0.418-0.96-0.939l-0-0.001v-10.24c0-0.53 0.43-0.96 0.96-0.96v0h3.8zM19.3 7.5c-0.389-0.51-0.996-0.837-1.679-0.84h-3.581v-2.38c0.002-0.043 0.003-0.094 0.003-0.145 0-2.11-1.71-3.82-3.82-3.82-0.071 0-0.142 0.002-0.213 0.006l0.010-0c-0.001 0-0.003-0-0.004-0-0.369 0-0.674 0.278-0.715 0.637l-0 0.003c-0.275 1.592-0.602 2.946-1.005 4.266l0.065-0.246c-0.436 0.995-1.191 1.783-2.134 2.248l-0.026 0.012v11.18c1.094 0.648 2.374 1.118 3.739 1.332l0.061 0.008h4.52c0.092 0.010 0.198 0.016 0.306 0.016 1.36 0 2.509-0.899 2.888-2.134l0.006-0.021c0.787-1.819 1.508-3.994 2.044-6.241l0.056-0.279c0.116-0.372 0.184-0.8 0.184-1.243 0-0.877-0.263-1.693-0.713-2.373l0.010 0.016z",
    fill: "url(#".concat(uniqueId, ")")
  }));
};

var _default = ThumbUpFill;
exports["default"] = _default;